/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {PropertyType} from './property-type';

/** Descriptions of properties used in the Multi-value widget. Currently only id, name, type and parentName are supported. */
export class PropertyDescription {
  id: number;
  name: string;
  type: PropertyType;
  multiple: boolean;
  parentId: number;
  parentName: string;
  possibleValues: Array<string>;
}
